import { Box } from "@mui/material";
import React from "react";

const Insights = () => {
  return <Box id="insights">Welcome to Insights</Box>;
};

export default Insights;
